import React from 'react';
import { connect } from 'react-redux';
import { storyActions } from '../../../../actions';
import { StoryActions } from '../../../design/LastPage/RecommendedStories';
import { goToLoginWithAction, isLogged } from '../../helpers';

class CustomStoryActions extends React.Component {

  componentDidMount() {
    if (sessionStorage.getItem('popcomics-webreader-subscribe-story') !== null) {
      if (!this.props.story.subscribed) {
        this.props.toggleSubscribe();
      }
      sessionStorage.removeItem('popcomics-webreader-subscribe-story');
    }
  }

  render() {
    const { subscribeLabel, story, t, toggleSubscribe, onReadAgain } = this.props;

    return (
      <StoryActions subscribe={subscribeLabel}
        disabled={story.subscribed}
        readAgain={t.read_again}
        onSubscribe={toggleSubscribe}
        onReadAgain={onReadAgain}
      />
    );
  }
}

const mapState = (state, ownProps) => ({
  subscribeLabel: ownProps.story.subscribed ? ownProps.t.subscribed : ownProps.t.subscribe
});

const mapDispatch = (dispatch, ownProps) => {
  const langPrefix = I18n.locale === 'en' ? '' : `/${I18n.locale}`;

  return {
    toggleSubscribe: (event) => {
      event && event.preventDefault();
      if (isLogged()) {
        if (!ownProps.story.subscribed) {
          dispatch(storyActions.storyToggleSubscribe(ownProps.story));
        }
      } else {
        goToLoginWithAction('popcomics-webreader-subscribe-story', ownProps.currentEpisode.id);
      }
    },
    onReadAgain: (event) => {
      event && event.preventDefault();
      window.location.href = `${langPrefix}/webreader/${ownProps.story.slug}/${ownProps.story.first_episode.slug}`;
    }
  };
};

export default connect(mapState, mapDispatch)(CustomStoryActions);
